import PropTypes from "prop-types";
import * as React from "react";

export function makeTreeItem(WrappedComponent) {
    class TreeItem extends React.Component {
        constructor(...args) {
            super(...args);
            this.toggleControl = this.toggleControl.bind(this);
        }

        toggleControl(e) {
            const {
                nodeKey,
                onChildCollapseOrExpand,
            } = this.props;

            onChildCollapseOrExpand(nodeKey);
            this.toggleCollapse(e);
        }

        toggleCollapse(e) {
            if (e) {
                e.preventDefault();
            }
        }

        render() {
            const {
                nodeKey = "",
                item,
                isKeyExpanded,
                onChildCollapseOrExpand,
                expanded = true,
                filter,
            } = this.props;
            const {
                children,
                depth = 0,
                type
            } = item;

            const hasChildren = children && children.length > 0;
            let items;
            if (hasChildren && expanded) {
                items = (typeof filter === "function" ? children.filter(filter) : children).map(m => {
                    const newItem = {
                        ...m,
                        depth: depth != null ? depth + 1 : undefined,
                        children: m.children,
                        parentType: type,
                    };

                    // todo: `cid` is bad here. and it's not cid anyway?
                    const childKey = nodeKey.length === 0
                            ? m.cid
                            : `${m.cid}.${nodeKey}`;
                    return (
                        <li key={childKey}>
                            <TreeItem
                                nodeKey={childKey}
                                isKeyExpanded={isKeyExpanded}
                                onChildCollapseOrExpand={onChildCollapseOrExpand}
                                expanded={!isKeyExpanded || isKeyExpanded(childKey)}
                                item={newItem}
                                filter={filter}
                            />
                        </li>
                    );
                });
            }

            return (
                <ul>
                    <WrappedComponent
                        {...this.props}
                        {...this.state}
                        expanded={expanded}
                        toggleControl={this.toggleControl}
                    />
                    {items}
                </ul>
            );
        }
    }

    TreeItem.propTypes = {
        nodeKey: PropTypes.string,
        isKeyExpanded: PropTypes.func,
        onChildCollapseOrExpand: PropTypes.func,
        expanded: PropTypes.bool,
        item: PropTypes.shape({
            children: PropTypes.array,
            depth: PropTypes.number,
            type: PropTypes.string,
            // and whatever else the actual itemRenderer needs
        }).isRequired,
        filter: PropTypes.func,
    };

    return TreeItem;
}



// WEBPACK FOOTER //
// ./app/lib/common/components/TreeItem.js